/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_OverlineInputs */

const en_mk_loop_overline = /** @type {(inputs: Mk_Loop_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP AGENT`)
};

const id_mk_loop_overline = /** @type {(inputs: Mk_Loop_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP AGENT`)
};

/**
* | output |
* | --- |
* | "BYSTEP AGENT" |
*
* @param {Mk_Loop_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_overline = /** @type {((inputs?: Mk_Loop_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_overline(inputs)
	return en_mk_loop_overline(inputs)
});